<template>
  <div class="service-pack-component">
    <el-row :gutter="20">
      <el-col :md="24" class="list-service-pack">
        <div
          v-for="item in listPacks"
          :key="item.id"
          @click="chooseServicePack(item)"
        >
          <div
            :id="item.id"
            :class="{
              'list-service-pack--item margin-20': true,
              clickSP: item.id === selectedServicePack.id,
            }"
          >
            <div class="bang-gia__services-block gold">
              <div class="icon-circle">
                <i class="fa-solid fa-circle-check"></i>
              </div>
              <div class="premium-block-wrapper">
                <p class="bang-gia__services-price">
                  <span>
                    <b>{{ formatCurrency(item.gia_niem_yet) }}</b>
                  </span>
                  <span>
                    /
                    {{
                      item.chu_ky_goi.loai === "quy"
                        ? "qúy"
                        : item.chu_ky_goi.loai === "nam"
                        ? "năm"
                        : item.chu_ky_goi.loai === "thang"
                        ? "tháng"
                        : ""
                    }}
                  </span>
                </p>
                <p class="bang-gia__services-name text-uppercase">
                  {{ item.ten }}
                </p>
                <ul class="bang-gia__services-feature">
                  <li>
                    <b>{{
                      returnDisplayInformation(
                        item.danh_sach_chuc_nang,
                        "THANH_VIEN"
                      ).gia_tri_hien_thi
                    }}</b>
                    <span>{{
                      returnDisplayInformation(
                        item.danh_sach_chuc_nang,
                        "THANH_VIEN"
                      ).ten
                    }}</span>
                  </li>
                  <li>
                    <b>{{
                      returnDisplayInformation(
                        item.danh_sach_chuc_nang,
                        "NGUOI_QUAN_LY"
                      ).gia_tri_hien_thi
                    }}</b>
                    <span>{{
                      returnDisplayInformation(
                        item.danh_sach_chuc_nang,
                        "NGUOI_QUAN_LY"
                      ).ten
                    }}</span>
                  </li>
                  <li>
                    <b>{{
                      returnDisplayInformation(
                        item.danh_sach_chuc_nang,
                        "DUNG_LUONG"
                      ).gia_tri_hien_thi
                    }}</b>
                    <span>{{
                      returnDisplayInformation(
                        item.danh_sach_chuc_nang,
                        "DUNG_LUONG"
                      ).ten
                    }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import MethodService from "../service/MethodService";
export default {
  props: ["listPacks", "listFunction", "backToPrePack"],
  data() {
    return {
      selectedServicePack: {},
    };
  },
  methods: {
    formatCurrency(value) {
      if (value === undefined) return;
      return MethodService.formatCurrencyVND(value);
    },
    chooseServicePack(servicePack) {
      if (servicePack.id === this.selectedServicePack.id) return;
      this.selectedServicePack = servicePack;
      this.$emit("chooseServicePack", this.selectedServicePack);
    },
    checkAndShowValueCard(feature) {
      const giaTriTuyBienHienThi = (this.listFunction || []).find(
        (x) => x.ma === feature.ma
      );
      let checkValueInTuyBien = false;
      if (giaTriTuyBienHienThi.tuy_bien_hien_thi) {
        checkValueInTuyBien =
          giaTriTuyBienHienThi.tuy_bien_hien_thi[0].gia_tri === feature.gia_tri;
      }
      if (!giaTriTuyBienHienThi.tuy_bien_hien_thi || !checkValueInTuyBien)
        return `${feature.ma === 'DUNG_LUONG' ? `${feature.gia_tri || ""}${giaTriTuyBienHienThi.don_vi || ""}` : `${feature.gia_tri || ""} ${giaTriTuyBienHienThi.don_vi || ""}`}` 

      return `${
        giaTriTuyBienHienThi.tuy_bien_hien_thi[0].gia_tri_hien_thi || ""
      } ${giaTriTuyBienHienThi.don_vi || ""}`;
    },
    returnDisplayInformation(listFeatures, key) {
      return {
        gia_tri_hien_thi: this.checkAndShowValueCard(
          listFeatures.find((x) => x.ma === key)
        ),
        ten:
          key === "THANH_VIEN"
            ? " trên cây gia phả"
            : key === "NGUOI_QUAN_LY"
            ? " quản lý"
            : key === "DUNG_LUONG"
            ? " dung lượng lưu trữ"
            : "",
      };
    },
  },
  watch: {
    backToPrePack: function () {
      this.selectedServicePack = this.backToPrePack;
      console.log("this.selectedServicePack", this.selectedServicePack);
    },
  },
};
</script>
<style lang="scss" default>
.list-service-pack {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  &--item {
    margin-bottom: 15px;
    border: 4px solid transparent;
    .bang-gia__services-block {
      width: 370px;
      height: 260px;
      position: relative;
      background: #ffffff;
      box-shadow: 0px 8px 24px 8px rgba(129, 129, 129, 0.11);
      border-radius: 20px;
      // padding: 81.5px 25px 48.5px 25px;
      padding: 30px 25px;
      border: 4px solid transparent;
      text-align: right;
      transition: 0.2s ease-out;
      cursor: pointer;
      .bang-gia__services-flag {
        position: absolute;
        height: 30px;
        width: 144px;
        border-radius: 13.5px;
        background-color: #fff1dc;
        top: 38.5px;
        right: 33px;
        font-family: Inter;
        font-weight: 500;
        font-size: 0.875rem;
        line-height: 17px;
        letter-spacing: 0.02em;
        color: #9e1c1e;
      }
      .bang-gia__services-price {
        font-family: Inter;
        font-weight: 600;
        font-size: 28px;
        line-height: 40px;
        color: #231d4f;
        text-align: right;
      }
      .bang-gia__services-name {
        font-family: PlayfairDisplay;
        text-transform: uppercase;
        font-weight: 700;
        font-size: 23px;
        line-height: 37px;
        letter-spacing: 0.03em;
        color: #9e1c1e;
        margin-bottom: 5px;
        text-align: left;
      }
      .bang-gia__services-feature {
        text-align: left;
        padding-left: 20px;
        li {
          list-style-image: url("/images/bullet.svg");
          width: 229px;
          font-family: Inter;
          font-weight: 400;
          line-height: 140%;
          letter-spacing: 0.03em;
          color: #585858;
          margin-bottom: 13px;
          font-size: 16px;
          b {
            font-weight: 600;
          }
        }
        .text-underline {
          text-decoration: underline;
        }
      }
      button {
        cursor: pointer;
        margin-top: 39px;
        height: 48px;
        width: 164px;
        border-radius: 8px;
        background-color: #ffca78;
        border: 3px solid #ffca78;
        font-family: Inter;
        font-weight: 500;
        font-size: 1.125rem;
        line-height: 150%;
        letter-spacing: 0.03em;
        color: #9e1c1e;
        transition: 0.2s ease-out;
      }
      &.gold,
      &.blue,
      &.specials {
        border-radius: 20px;
        &:before {
          position: absolute;
          top: 7.5px;
          right: 7.5px;
          bottom: 7.5px;
          left: 7.5px;
          border-radius: 20px;
          background: linear-gradient(
            180deg,
            #f9bc60 0%,
            #ffca78 20.31%,
            #fed9b7 53.12%,
            #fac96a 76.04%,
            #e0ab45 100%
          );
          content: "";
          z-index: 0;
        }
        &:after {
          position: absolute;
          top: 9.5px;
          right: 9.5px;
          bottom: 8.5px;
          left: 9.5px;
          border-radius: 19px;
          content: "";
          z-index: 0;
        }
      }
      &.gold {
        background-color: #fff1dc;
        &:after {
          background-color: #fff1dc;
        }
        button {
          background-color: #9e1c1e;
          border: 3px solid #9e1c1e;
          color: #ffffff;
        }
      }
      &.blue {
        background-color: #003168;
        &:after {
          background-color: #003168;
        }
        .bang-gia__services-price {
          color: #ffca78;
        }
        .bang-gia__services-name {
          color: #ffca78;
        }
        .bang-gia__services-feature {
          // list-style-image: url("/bullet-gold.svg");
          li {
            color: #ffffff;
            list-style: none;
          }
        }
      }
      &.specials {
        background-color: #9e1c1e;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
        .bang-gia__services-flag {
          top: -82px;
          right: -6px;
        }
        .bang-gia__services-name {
          height: 70px;
          width: 100%;
          background: linear-gradient(
            100deg,
            #f9bc60 5.03%,
            #ffca78 21.62%,
            #fed9b7 48.42%,
            #fac96a 67.14%,
            #e0ab45 86.71%
          );
          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
          border-radius: 10px;
          color: #9e1c1e;
          margin-top: 35px;
          margin-bottom: 64px;
        }
        .bang-gia__services-feature {
          // list-style-image: url("/bullet-gold.svg");
          li {
            color: #ffffff;
          }
        }
        img {
          position: absolute;
          width: 100%;
          top: 0;
          left: 0;
          z-index: 1;
        }
        &:after {
          background-color: #9e1c1e;
        }
        .specials-content {
          position: relative;
          z-index: 10;
        }
      }
      .premium-block-wrapper {
        position: relative;
        z-index: 10;
        .bang-gia__services-flag {
          top: -43px;
          right: -4px;
        }
      }
      .icon-circle {
        display: none;
        position: absolute;
        right: 15px;
        top: 17px;
        z-index: 1;
        .fa-solid {
          width: 25px;
          height: 25px;
          font-size: 18px;
          color: #1dbe1c;
        }
      }
    }
    &.clickSP {
      border: 4px solid #ffca78;
      border-radius: 24px;
      .icon-circle {
        display: inline;
      }
    }
  }
}
</style>
